const iconsSrc: string[] = [
  'repast',
  'traffic',
  'shopping',
  'clothes',
  'amusement',
  'redEnvelope',
  'livingExpenses',
  'smokeWine',
  'fruits',
  'dailyUse',
  'beauty',
  'housing',
  'communication',
  'vegetable',
  'learn',
  'travel',
  'sports',
  'child',
  'pet',
  'home',
  'book',
  'repair',
  'medical',
  'digital',
  'contribute',
  'cashGift',
  'gift',
  'official',
  'social',
  'oldMan',
  'lottery',
  'snacks',
  'delivery',
  'laborage',
  'partTime',
  'financing',
  'reimbursement',
  'bonus',
  'other',
];
export default iconsSrc;

